import {ReactNode, useMemo} from 'react';
import selectIcon from '../../../../assets/icons/select-icon.svg?no-inline';
import selfieIcon from '../../../../assets/icons/selfie.svg?no-inline';
import PassportSvg from '../../../../assets/icons/passport-icon-standar.svg?react';
import ContactSvg from '../../../../assets/icons/contact-verify.svg?react';
import PhoneSvg from '../../../../assets/icons/phone-verify.svg?react';
import EmailSvg from '../../../../assets/icons/email-verify.svg?react';

export type VerificationStepData = {
  icon: ReactNode;
  text: string;
};

type UseGetVerificationStepsParams = {
  biomatch: boolean;
  isLivenessDetectionEnabled?: boolean;
  isEmailEnabled?: boolean;
  isPhoneEnabled?: boolean;
  isNeedContactsVerification?: boolean;
};

export const useGetVerificationSteps = ({
  biomatch,
  isLivenessDetectionEnabled = false,
  isEmailEnabled = false,
  isPhoneEnabled = false,
  isNeedContactsVerification = false,
}: UseGetVerificationStepsParams): VerificationStepData[] => {
  return useMemo(() => {
    const VERIFICATION_STEPS = {
      scanDoc: {
        icon: <PassportSvg className="kiosko:w-[78px] kiosko:h-auto" />,
        text: 'scan_document',
      },
      takeSelfie: {
        icon: <img src={selfieIcon} alt="Selfie" />,
        text: 'take_selfie',
      },
      checkFace: {
        icon: <img src={selfieIcon} alt="Selfie" />,
        text: 'check_face',
      },
      selectDoc: {
        icon: (
          <img src={selectIcon} alt="Select" className="kiosko:w-[110px] kiosko:h-auto" />
        ),
        text: 'select_document',
      },
      emailPhone: {
        icon: <ContactSvg className="kiosko:w-[78px] kiosko:h-auto" />,
        text: 'verify_contacts',
      },
      phone: {
        icon: <PhoneSvg className="kiosko:w-[78px] kiosko:h-auto" />,
        text: 'verify_phone',
      },
      email: {
        icon: <EmailSvg className="kiosko:w-[78px] kiosko:h-auto" />,
        text: 'verify_email',
      },
    };

    const steps = [];
    if (isNeedContactsVerification) {
      if (isEmailEnabled && isPhoneEnabled) {
        steps.push(VERIFICATION_STEPS.emailPhone);
      } else if (isEmailEnabled) {
        steps.push(VERIFICATION_STEPS.email);
      } else if (isPhoneEnabled) {
        steps.push(VERIFICATION_STEPS.phone);
      }
    }

    if (biomatch) {
      steps.push(
        VERIFICATION_STEPS.scanDoc,
        isLivenessDetectionEnabled
          ? VERIFICATION_STEPS.checkFace
          : VERIFICATION_STEPS.takeSelfie,
      );
    } else {
      steps.push(VERIFICATION_STEPS.selectDoc, VERIFICATION_STEPS.scanDoc);
    }

    return steps;
  }, [
    biomatch,
    isLivenessDetectionEnabled,
    isEmailEnabled,
    isPhoneEnabled,
    isNeedContactsVerification,
  ]);
};
